import { useState } from "react";
import apiJurados from "../api/Jurados/api-jurados";

interface Invitacion {
    invitacion_profesional: any;
    nombre_completo: string;
    correo: string;
}

export const useInvitacionJurados = () => {

    const [invitacion, setInvitacion] = useState<Invitacion>(initialValues);
    const [openModal, setOpenModal] = useState(false);

    const enviarInvitacion = async() => {
        try {
            await apiJurados.invitacionJurado(invitacion);
            setOpenModal(true);
        } catch (error) {
            console.log(error)
        }
    }

    return {
        invitacion,
        setInvitacion,
        enviarInvitacion,
        openModal,
        setOpenModal
    }
}


const initialValues = {
    invitacion_profesional: null,
    nombre_completo: '',
    correo: ''
}